import { render, staticRenderFns } from "./un_verify_list.vue?vue&type=template&id=0fcb63a8"
import script from "./un_verify_list.vue?vue&type=script&lang=js"
export * from "./un_verify_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports